import { LightRoutingLink, PrimaryButton } from "components/buttons/buttons";
import WorkArea from "components/work-area/work-area";
import PagosMultiplesTable from "../components/pagos-multiples.table";
import usePagos from "./use-pagos";

const PagosMultiplesPage = () => {
	const {
		cargandoDatos,
		pagos,
		pagar
	} = usePagos();

	return (
		<WorkArea title="Pagar" path={["Pagar"]}>
			<div>
				<div className="comprobante-banorte table-seleccion">
					<div className="c-body">
						<div className="row">
							<div className="col-12">
								<PagosMultiplesTable pagos={pagos} />
							</div>
						</div>
					</div>
					<div className="c-footer">
						<div className="text-end">
							<LightRoutingLink disabled={cargandoDatos} className="me-3" to="/:segmento">Regresar</LightRoutingLink>
							<PrimaryButton disabled={cargandoDatos} className="me-5" onClick={pagar}>Pagar</PrimaryButton>
						</div>
					</div>
				</div>
			</div>
		</WorkArea>
	);
};

export default PagosMultiplesPage;